import React from "react";
import Faq from "../../components/Faq/Faq";
import "./FaqPage.css";


const FaqPage = () => {
  return (
    <div className="faqSection">
      <h2>Frequently Asked Questions</h2>
      <Faq />
    </div>
  );
};

export default FaqPage;
